import { default as CandidateType, CandidateProfileType } from '../../model/hros/recruiting/CandidateType';
import { CombinedAddressType } from '../../model/hros/common/communication/AddressTypeArray';
import { default as EmployerHistoryType, PositionHistoryType } from '../../model/hros/common/profile/EmployerHistoryType';
import OrganizationType from '../../model/hros/common/organization/OrganizationType';
import AddressComponentType from '../../model/hros/common/communication/AddressComponentType';
import { EmploymentHistoryIsEmpty } from '../../components/profile';
import { IEmploymentHistoryInstanceForm } from '../../model/forms';
import { DefaultTypeIdentifiersCodeList } from '../../model/hros/common/codelist/DefaultTypeIdentifiersCodeList';
import { FormatAddress } from './FormatAddress';

export function ProfileFormEmploymentHistoriesToHROS(src: Map<number, IEmploymentHistoryInstanceForm>, dest: CandidateType) : boolean {
  let employmentHistories: EmployerHistoryType[] = [];
  if (src.size !== 0) {
    src.forEach((value: IEmploymentHistoryInstanceForm) => {
      if (EmploymentHistoryIsEmpty(value)) {
        return;
      }

      let employmentHistory: EmployerHistoryType = {};
      let employmentHistoryModified = false; 

      let organization: OrganizationType = {};
      let organizationModified = false;
      
      if (value.organizationName !== undefined) {
        organization.name = value.organizationName.trim();
        organizationModified = true;
      }

      let formattedAddress = FormatAddress(value.organizationAddress, value.organizationCity, value.organizationState, value.organizationPostalCode, value.organizationCountry);
      if (formattedAddress !== undefined) {        
        let address: CombinedAddressType = {
          formattedAddress: formattedAddress
        };

        if (value.organizationAddress !== undefined) {
          address.line = value.organizationAddress.trim();
        }
        if (value.organizationCity !== undefined) {
          address.city = value.organizationCity.trim();
        }

        if (value.organizationPostalCode !== undefined) {
          address.postalCode = value.organizationPostalCode.trim();
        }

        if (value.organizationCountry !== undefined) {
          address.countryCode = value.organizationCountry.trim();
        }

        if (value.organizationState !== undefined) {
          address.countrySubDivisions = [
            {
              type: DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE,
              value: value.organizationState.trim()
            }
          ];
        }

        organization.communication = {
          address: [ address ]
        };
        organizationModified = true;
      }

      let positionHistory: PositionHistoryType = {};
      let positionHistoryModified = false;

      if (value.title !== undefined) {
        positionHistory.title = value.title.trim();
        positionHistoryModified = true;
      }

      if (value.start !== undefined) {
        positionHistory.start = value.start.trim();
        positionHistoryModified = true;
      }

      if (value.end !== undefined) {
        positionHistory.end = value.end.trim();
        positionHistoryModified = true;
      }

      if (value.description !== undefined) {
        positionHistory.descriptions = [ value.description.trim() ];
        positionHistoryModified = true;
      }

      if (positionHistoryModified) {
        employmentHistory.positionHistories = [ positionHistory ];
        employmentHistoryModified = true;
      }

      if (organizationModified) {
        employmentHistory.organization = organization;
        employmentHistoryModified = true;
      }
      
      if (employmentHistoryModified)
      {
        employmentHistories.push(employmentHistory);
      }
    });
  }
  
  if (employmentHistories.length === 0) {
    return false;
  }

  dest.profiles![0].employment = employmentHistories;
  return true;
}

export function HROSToProfileFormEmploymentHistories(src: CandidateType, dest: Map<number, IEmploymentHistoryInstanceForm>) {
  if (src?.profiles === undefined || src.profiles.length === 0) {
    return;
  }

  let profile = src.profiles.find((value: CandidateProfileType) => value.profileId?.schemeId === DefaultTypeIdentifiersCodeList.CANDIDATE_PROFILE_TYPE_DEFAULT) || src.profiles[0];
  if (profile.employment === undefined || profile.employment.length === 0) {
    return;
  }
  profile.employment.forEach((value: EmployerHistoryType) => {
    let employmentHistory: IEmploymentHistoryInstanceForm = {
      instanceId: dest.size + 1
    };
    let employmentHistoryModified = false;

    if (value.organization?.name !== undefined) {
      employmentHistory.organizationName = value.organization.name;
      employmentHistoryModified = true;
    }
    
    if (value.organization?.communication?.address?.[0]?.line !== undefined) {
      employmentHistory.organizationAddress = value.organization.communication.address[0].line;
      employmentHistoryModified = true;
    }
    
    if (value.organization?.communication?.address?.[0]?.city !== undefined) {
      employmentHistory.organizationCity = value.organization.communication.address[0].city;
      employmentHistoryModified = true;
    }
    
    if (value.organization?.communication?.address?.[0]?.postalCode !== undefined) {
      employmentHistory.organizationPostalCode = value.organization.communication.address[0].postalCode;
      employmentHistoryModified = true;
    }
    
    if (value.organization?.communication?.address?.[0]?.countrySubDivisions !== undefined) {
      let state = value.organization.communication.address[0].countrySubDivisions.find((value: AddressComponentType) => value.type?.toUpperCase() === DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE);
      if (state?.value !== undefined) {
        employmentHistory.organizationState = state.value;
        employmentHistoryModified = true;
      }
    }
    
    if (value.organization?.communication?.address?.[0]?.countryCode !== undefined) {
      employmentHistory.organizationCountry = value.organization.communication.address[0].countryCode;
      employmentHistoryModified = true;
    }
    
    if (value.positionHistories?.[0]?.title !== undefined) {
      employmentHistory.title = value.positionHistories[0].title;
      employmentHistoryModified = true;
    }
        
    if (value.positionHistories?.[0]?.start !== undefined) {
      employmentHistory.start = value.positionHistories[0].start;
      employmentHistoryModified = true;
    }
    
    if (value.positionHistories?.[0]?.end !== undefined) {
      employmentHistory.end = value.positionHistories[0].end;
      employmentHistoryModified = true;
    }
    
    if (value.positionHistories?.[0]?.descriptions !== undefined && value.positionHistories[0].descriptions.length > 0) {
      employmentHistory.description = value.positionHistories[0].descriptions[0];
      employmentHistoryModified = true;
    }

    if (employmentHistoryModified) {
      dest.set(employmentHistory.instanceId, employmentHistory);
    }
  });
}